import { chef, spices, recipe } from '../../../../../index';
import { buttonLinedSoftTpl, buttonIcoBurgerTpl } from '../../buttons';
import './styles';

const headerMainTpl = () => {
    return ``;
}

export default headerMainTpl;